import { styled } from 'styled-components'

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 1rem 1.25rem;
  align-self: center;
  gap: 16px;
`

export const ResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 82px;
`

export const TextContainer = styled.div`
  margin-top: 16px;
`

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 16px;
  height: 2rem;
`
